import React, { useState } from "react";
import { createUserWithEmailAndPassword, signOut } from "firebase/auth";
import {
  doc,
  setDoc,
  updateDoc,
  collection,
  getDocs,
  query,
  where,
} from "firebase/firestore";
import { auth, db } from "./Firebase";
import ListarUsuarios from "./ListarUsuarios";
import styled from "styled-components";
import { Alert, CloseButton } from "./App";

const ContenedorDiv = styled.div`
  margin: 20px 0px 40px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  & input,
  select {
    background-color: rgba(255, 255, 255, 0.4);
    border: 1px solid #ccc;
    border-radius: 2px;
    width: 200px;
    &:focus {
      outline: none;
      color: #1f2124;
    }
  }
  &.classInput input:focus {
    color: white;
  }
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    margin-bottom: 20vh;
  }
`;
const ContenedorForm = styled.form`
  margin: 30px 0px 20px 0px;
  display: flex;
  gap: 25px;
  align-items: center;
  width: 450px;
  flex-wrap: wrap;
  justify-content: space-between;
  @media only screen and (min-width: 320px) and (max-width: 768px) {
    width: 250px;
    justify-content: center;
  }
`;
const InputContenedor = styled.div`
  position: relative;
  & label {
    font-size: small;
    position: absolute;
    top: -20px;
    left: 10px;
    padding: 0 5px;
  }
`;
const EstiloButton = styled.button`
  padding: 5px 12px 5px 12px;
  background-color: #6a6e73;
  color: black;
  border: none;
  border-radius: 2px;
  border-bottom: solid 1.5px #fb3b3b;
  &:hover {
    color: white;
    background-color: rgb(41, 41, 41);
    transition: 0.3s;
  }
`;

const CrearUsuario = ({ setMostrarUsuario }) => {
  const [nombre, setNombre] = useState("");
  const [apellido, setApellido] = useState("");
  const [empresa, setEmpresa] = useState("");
  const [sector, setSector] = useState("");
  const [correo, setCorreo] = useState("");
  const [password, setPassword] = useState("");
  const [perfil, setPerfil] = useState("");
  const [state, setState] = useState("offline");
  const [connections, setConnections] = useState("");
  const [showAlertDatos, setShowAlertDatos] = useState(false);
  const [showAlertError, setShowAlertError] = useState(false);
  const [showAlert, setShowAlert] = useState(false);
  const [showAlertCorreo, setShowAlertCorreo] = useState(false);
  const closeAlert = () => {
    setShowAlertDatos(false);
    setShowAlertError(false);
    setShowAlert(false);
    setShowAlertCorreo(false);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (
      !nombre ||
      !apellido ||
      !empresa ||
      !sector ||
      !correo ||
      !password ||
      !perfil
    ) {
      setShowAlert(true);
      return;
    }

    try {
      //verifica si el correo que quiere crear existe
      const usersRef = collection(db, "users");
      const q = query(usersRef, where("correo", "==", correo));
      const querySnapshot = await getDocs(q);

      if (!querySnapshot.empty) {
        setShowAlertCorreo(true);
        return;
      }
      // Cerrar la sesión del usuario actual
      const userOnlineRef = doc(db, "users", auth.currentUser.uid);
      await updateDoc(userOnlineRef, { state: "offline" });
      await signOut(auth);

      // Crear el usuario en Firebase Authentication
      const userCredential = await createUserWithEmailAndPassword(
        auth,
        correo,
        password
      );

      // Obtener el ID de usuario
      const userId = userCredential.user.uid;

      // Crear un documento de usuario en Firestore
      const userRef = doc(db, "users", userId);
      const userData = {
        nombre,
        apellido,
        empresa,
        sector,
        correo,
        perfil,
        state,
        connections,
      };
      await setDoc(userRef, userData);

      // Limpiar los campos del formulario
      setNombre("");
      setApellido("");
      setEmpresa("");
      setSector("");
      setCorreo("");
      setPassword("");
      setPerfil("");
      setState("offline");
      setConnections("");

      // Redirige a la página principal
      setMostrarUsuario(false);

      setShowAlertDatos(true);
    } catch (error) {
      setShowAlertError(true);
    }
  };

  return (
    <ContenedorDiv>
      {showAlertCorreo && (
        <Alert>
          <CloseButton onClick={closeAlert}>&times;</CloseButton>
          El correo electrónico ya está registrado.
        </Alert>
      )}
      {showAlert && (
        <Alert>
          <CloseButton onClick={closeAlert}>&times;</CloseButton>
          Por favor, complete los campos vacios.
        </Alert>
      )}
      {showAlertDatos && (
        <Alert>
          <CloseButton onClick={closeAlert}>&times;</CloseButton>
          Usuario creado con éxito.
        </Alert>
      )}
      {showAlertError && (
        <Alert>
          <CloseButton onClick={closeAlert}>&times;</CloseButton>
          Error al guardar los datos.
        </Alert>
      )}
      <div>
        <h4>Nuevo Usuario</h4>
        <ContenedorForm onSubmit={handleSubmit}>
          <InputContenedor>
            <label htmlFor="nombre">Nombre:</label>
            <input
              type="text"
              value={nombre}
              onChange={(e) => setNombre(e.target.value)}
            />
          </InputContenedor>
          <InputContenedor>
            <label htmlFor="apellido">Apellido:</label>
            <input
              type="text"
              value={apellido}
              onChange={(e) => setApellido(e.target.value)}
            />
          </InputContenedor>
          <InputContenedor>
            <label htmlFor="empresa">Empresa:</label>
            <input
              type="text"
              value={empresa}
              onChange={(e) => setEmpresa(e.target.value)}
            />
          </InputContenedor>
          <InputContenedor>
            <label htmlFor="sector">Sector:</label>
            <input
              type="text"
              value={sector}
              onChange={(e) => setSector(e.target.value)}
            />
          </InputContenedor>
          <InputContenedor>
            <label htmlFor="correo">Correo:</label>
            <input
              type="email"
              value={correo}
              onChange={(e) => setCorreo(e.target.value)}
            />
          </InputContenedor>
          <InputContenedor>
            <label htmlFor="password">Contraseña:</label>
            <input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
            />
          </InputContenedor>
          <InputContenedor>
            <label htmlFor="perfil">Perfil:</label>
            <select value={perfil} onChange={(e) => setPerfil(e.target.value)}>
              <option value="">Seleccionar</option>
              <option value="comercial">Comercial</option>
              <option value="terminal">Terminal</option>
              <option value="turismo">Turismo</option>
              <option value="administrador">Administrador</option>
            </select>
          </InputContenedor>
          <EstiloButton type="submit">Crear Usuario</EstiloButton>
        </ContenedorForm>
      </div>
      <div>
        <ListarUsuarios />
      </div>
    </ContenedorDiv>
  );
};

export default CrearUsuario;
